import popper from 'popper.js';
import 'slick-carousel';
import 'bootstrap/util';
import 'bootstrap/modal';
import 'infinite-scroll';

const initPairTheme = function () {
	const product_ids = [];

	function populateProductQty() {
		const cartData = fetch('/cart.js')
			.then(res => res.json())
			.then(cartJSON => {
				if (cartJSON.items.length > 0) {
					cartJSON.items.forEach(value => {
						product_ids.push(value.id);

						var input = $(`input#item_quantity-${value.id}`);
						input.val(value.quantity);

						if (value.quantity) {
							input.parents('.quantify').find('.btn.minus').removeClass('muted');
						}
					});
				}
			})
			.catch(error => console.error('Error fetching cart: Cart.js may not exist', error.message));
	}

	/**
	 * Pair Eyeware Shopify Cart
	 * Used to modify cart and cart items information.
	 */
	const Cart = new (function () {
		var instance = this;

		/**
		 *
		 *
		 * @param {*} item
		 * @param {*} line
		 */
		class Item {
			constructor(item, line) {
				var instance = this;

				/**
				 * [description]
				 * @param  {object} data  [description]
				 * @return {[type]}       [description]
				 */
				instance.change = function (success) {
					return $.ajax({
						url: '/cart/change.js',
						type: 'post',
						global: false,
						data: {
							line: instance.line,
							properties: instance.data.properties,
							quantity: instance.data.quantity,
						},
						dataType: 'json',
						success: function (cart) {
							if (typeof success == 'function') {
								success.call(success, cart);
							}
						},
					});
				};
				(function construct(instance, item, line) {
					instance.data = item;
					instance.line = line;
				})(this, item, line);
			}
		}

		instance.Items = new (function () {
			var instance = this;
			var items = [];

			instance.prescription = function () {
				var glasses = [];

				if (items.length) {
					for (var index in items) {
						var Item = items[index];

						if (Item.data.variant_options.indexOf('Prescription') > -1) {
							glasses.push(Item);
						}
					}
				}

				return glasses;
			};

			instance.add = function (item) {
				items.push(new Item(item, items.length + 1));
			};

			instance.clear = function () {
				items = [];
			};

			instance.get = function (id) {
				for (var index in items) {
					if (items[index].data.id == id) {
						return items[index];
					}
				}

				return null;
			};

			instance.all = function () {
				return items;
			};
		})();

		instance.add = function (data, success) {
			return $.ajax({
				url: '/cart/add.js',
				type: 'post',
				dataType: 'json',
				async: false,
				global: false,
				data: data,
				success: function (cart) {
					// instance.load(cart);

					if (typeof success == 'function') {
						success.call(success, cart);
					}
				},
			});
		};

		instance.update = function (data, success) {
			return $.ajax({
				url: '/cart/update.js',
				type: 'post',
				dataType: 'json',
				async: false,
				global: false,
				data: data,
				success: function (cart) {
					// instance.load(cart);

					if (typeof success == 'function') {
						success.call(success, cart);
					}
				},
			});
		};

		instance.get = function (success) {
			return $.ajax({
				url: '/cart.js',
				type: 'get',
				dataType: 'json',
				global: false,
				success: function (cart) {
					instance.load(cart);

					if (typeof success == 'function') {
						success.call(success, cart);
					}
				},
			});
		};

		instance.load = function (cart) {
			instance.Items.clear();

			instance.data = cart;

			for (var index in cart.items) {
				instance.Items.add(cart.items[index]);
			}
		};
		(function construct(instance) {})(this);
	})();

	Cart.get();

	/**
	 * Pair Eyeware US States Loader
	 * Used to get US states.
	 */
	const States = new (function () {
		var instance = this;
		var states = {};

		instance.get = function (success) {
			$.ajax({
				url: theme.statesURL,
				type: 'get',
				dataType: 'json',
				global: false,
				success: function (response) {
					states = response;

					if (typeof success == 'function') {
						success.call(success, response);
					}
				},
			});
		};

		instance.all = function () {
			return states;
		};
		(function construct(instance) {
			instance.get();
		})(this);
	})();

	/**
	 * TEMPLATE: Home / Index
	 */
	if (template === 'index') {
		const $home__testimonials = $('.testimonials__slider .slider-container');
		if ($home__testimonials.length) {
			$home__testimonials.slick({
				slidesToShow: 3,
				arrows: false,
				autoplay: false,
				responsive: [
					{
						breakpoint: 992,
						settings: {
							centerMode: true,
							slidesToShow: 2,
							dots: false,
							autoplay: true,
							autoplaySpeed: 2000,
						},
					},
					{
						breakpoint: 768,
						settings: {
							centerMode: true,
							slidesToShow: 1,
							dots: false,
							autoplay: true,
							autoplaySpeed: 2000,
						},
					},
				],
			});
		}
	}

	/**
	 *  TEMPLATE: Cart
	 */
	var minicartIsSetup = false;
	const cartTemplateSetup = () => {
		var template = $('body.template-cart').length ? $('body.template-cart') : $('#itemsRoot');
		var modals = {
			Upload: $('.modal#prescription'),
			Call: $('.modal#doctor-contact-sheet'),
			Send: $('.modal#send-later'),
		};

		var cartQuantityButton = {
			minus: template.find('button.minus'),
			plus: template.find('button.plus'),
		};

		/**
		 * Upload Prescription Form Class
		 *
		 * @param  {object} The contact data object
		 * @return {object} The Contact object
		 */
		var Prescripts = function (contact) {
			var instance = this;
			var form = null;

			/**
			 * Submit
			 * @return {object} jqXHR
			 */

			this.validate = function (form) {
				var state = true;

				form.find('input, select').removeClass('is-invalid');
				form.find('.form-text').addClass('d-none');

				var valid = true;

				form.find('[required]').each(function () {
					var value = $.trim($(this).val());

					if (value == '') {
						state = false;

						$(this).addClass('is-invalid').siblings('.form-text').removeClass('d-none');
					}
				});

				return state;
			};

			/**
			 * Set
			 * @return {object} Contact
			 */
			this.set = function (contact) {
				if (contact) {
					var lens = 'Prescription Lenses';

					form = new FormData();

					form.append('first_name', contact.patient_first_name);
					form.append('last_name', contact.patient_last_name);
					form.append('email', contact.doctor);
					form.append('lens_type', lens);
				}

				return instance;
			};
			(function construct(instance, contact) {
				if (contact) {
					instance.set(contact);
				}
			})(this, contact);
		};

		/**
		 * Doctor Contact Form Class
		 *
		 * @param  {object} The contact data object
		 * @return {object} The Contact object
		 */
		var Contact = function (contact) {
			var instance = this;
			var form = null;

			/**
			 * Submit
			 * @return {object} jqXHR
			 */
			this.submit = function () {
				if (form) {
					return $.ajax({
						url: `${POMS_URL}/api/doctor/upload`,
						method: 'post',
						global: false,
						data: form,
						contentType: false,
						processData: false,
					});
				}
			};

			this.validate = function (form) {
				var state = true;

				function isValidPhone(number) {
					if (!number || number.length !== 12) {
						return false;
					}
					var phoneRx = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/g;
					return number.match(phoneRx);
				};

				function isValidDate(dob) {
					if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dob)) return false;

					var parts = dob.split('/');
					var day = parseInt(parts[1], 10);
					var month = parseInt(parts[0], 10);
					var year = parseInt(parts[2], 10);

					if (year < 1000 || year > 3000 || month === 0 || month > 12) return false;

					var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

					if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) monthLength[1] = 29;

					return day > 0 && day <= monthLength[month - 1];
				};

				form.find('input, select').removeClass('is-invalid');
				form.find('.form-text').addClass('d-none');

				var valid = true;

				form.find('[required]').each(function (_, {name}) {
					var value = $.trim($(this).val());

					if(value === '') {
						state = false;
						$(this).addClass('is-invalid').siblings('.required').removeClass('d-none');
					} else if(name === 'clinic_phone' && !isValidPhone(value)){
						state = false;
						$(this).addClass('is-invalid').siblings('#invalid_clinic_phone').removeClass('d-none');
					} else if(name === 'patient_birthdate' && !isValidDate(value)) {
						state = false;
						$(this).addClass('is-invalid').siblings('#invalid_patient_birthdate').removeClass('d-none');
					}
				});

				return state;
			};

			/**
			 * Set
			 * @return {object} Contact
			 */
			this.set = function (contact) {
				if (contact) {
					form = new FormData();

					form.append('patient_name', contact.full_name);
					form.append('patient_dob', contact.birthday);
					form.append('doctor_clinic_name', contact.clinic);
					form.append('doctor_phone_number', contact.phone);
					form.append('doctor_state', contact.state);
					form.append('key', contact.key);
				}

				return instance;
			};
			(function construct(instance, contact) {
				if (contact) {
					instance.set(contact);
				}
			})(this, contact);
		};

		// Highlight 'I'll email it later' option on page load
		template.find('button#prescription-send').addClass('option-selected');

		template.on('click', '#prescription-option', function (e) {
			// Toggle the active-line-item class to track which line item was clicked on
			template.find('.active-line-item').removeClass('active-line-item');
			$(e.currentTarget).addClass('active-line-item');
			$(this).find('.option-selected').removeClass('option-selected');
			$(e.target).closest('button').addClass('option-selected');
		});

		let photoTrigger = '.cell.photo';
		let doctorTrigger = '.cell.doctor';

		template.on('click', photoTrigger, function (e) {
			$(e.currentTarget).siblings('[name="prescription-photo"]').trigger('click');
			setActiveGroupItem(e.target);
		});

		if (window.template !== 'cart') {
			template.on('change', '[name="prescription-photo"]', function (event) {
				var input = $(this);
				var files = input[0].files;
				var bundleKey = template.find('.active-item-group').closest('[data-bundle]').attr('data-bundle');

				var bundle = {
					key: new Date().getTime(),
				};

				if (files.length) {
					var file = files[0];

					var data = new FormData();
					data.append('file', file);
					data.append('key', bundleKey);

					var buttons = {
						upload: template.find('#prescription-upload'),
						call: template.find('#prescription-call'),
						send: template.find('#prescription-send'),
					};

					$.ajax({
						url: `${process.env.POMS_URL}/api/prescription/upload`,
						type: 'post',
						global: false,
						contentType: false,
						processData: false,
						data: data,
						success: function (response) {
							const fileNameDiv = document.querySelector('#fileName');
							fileNameDiv.innerHTML = file.name;

							const divider = document.querySelector('.divider');
							divider.style.display = 'block';

							const trashIcon = document.querySelector('.trashIcon');
							trashIcon.style.display = 'block';

							const reupload = document.querySelector('.uploadText');
							reupload.innerHTML = 'Upload new';
							const photoCell = document.querySelector('[data-method="photo"]');
							handleCellClick(photoCell);

							var requests = [];
							var glasses = Cart.Items.prescription();
							for (var index in glasses) {
								var glass = glasses[index];

								glass.data.properties['Prescription ID'] = response.file.key;
								glass.data.properties['Prescription Type'] = 'Photo';

								requests.push(glass.change());
							}

							var defer = $.when.apply($, requests);
							defer.done(function () {
								/* Any implementation after changing
									   cart line item. */
							});
						},
					}).always(function () {
						input.val(null);

						buttons.call.add(buttons.send).prop('disabled', false);

						template
							.find('.active-line-item #prescription-upload')
							.append('<p class="status bold"><span class="checkmark">&check;</span>&nbsp;Uploaded</p>');
					});
				}
			});
		}

		template.on('click', doctorTrigger, function (event) {
			if (window.template !== 'cart') {
				modals.Call.modal('show');
			}
			setActiveGroupItem(event.target);
		});

		modals.Call.one('show.bs.modal', function() {
			var select = $(this).find('select[name="clinic_state"]');
			var states = States.all();
			for (var key in states) {
				select.append($('<option />').attr('value', key).text(states[key]));
			}
		});

		if (window.template !== 'cart') {
			modals.Call.on('click', '#submit-call', function() {
				var form = modals.Call.find('form');

				var contact = new Contact();

				if (contact.validate(form)) {
					var requests = [];

					var bundleKey = template.find('.active-item-group').closest('[data-bundle]').attr('data-bundle');

					var bundle = {
						key: new Date().getTime(),
					};

					var prescription = {
						contact: {
							full_name: form.find('[name="patient_full_name"]').val(),
							birthday: form.find('[name="patient_birthdate"]').val(),
							clinic: form.find('[name="clinic_name"]').val(),
							state: form.find('[name="clinic_state"]').val(),
							phone: form.find('[name="clinic_phone"]').val(),
							key: bundleKey,
						},
					};

					// Submit Doctor Contact Form to Pair API
					contact
						.set(prescription.contact)
						.submit()
						.then(function(response) {
							var requests = [];
							var glasses = Cart.Items.prescription();

							for (var index in glasses) {
								var glass = glasses[index];

								glass.data.properties['Prescription ID'] = response.key;
								glass.data.properties['Prescription Type'] = 'Contact Form';

								requests.push(glass.change());
							}

							var defer = $.when.apply($, requests);
							defer.done(function() {
								/** Any implementation after changing
								 * cart line item.
								 */
							});

							template
								.find('.active-line-item #prescription-call')
								.append('<p class="status bold"><span class="checkmark">&check;</span>&nbsp;Uploaded</p>');

							// Close Modal
							modals.Call.one('hide.bs.modal', function() {
							}).modal('hide');

							// Update UI and Submission Method
							const doctorCell = document.querySelector('[data-method="doctor"]');
							handleCellClick(doctorCell);
						});
				}
			});
		}

		template.on('click', 'button#submit-send-later', function (event) {
			var form = modals.Send.find('form');
			var input = $(this);
			var bundleKey = template.find('.active-line-item').closest('[data-bundle-key]').attr('data-bundle-key');

			var buttons = {
				upload: template.find('#prescription-upload'),
				call: template.find('#prescription-call'),
				send: template.find('#prescription-send'),
			};

			function formatDate(date) {
				var strTime = date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
				return date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear() + '  ' + strTime;
			}

			var d = new Date();
			var now = formatDate(d);
			var url =
				'https://script.google.com/macros/s/AKfycbyU82Gm3ebshEd6Sy-F_QoQu16iFtBsRcZOxM6SnCY3dbFXpJY/exec?' +
				'datetime=' +
				now +
				'&First_Name=' +
				encodeURIComponent(form.find('[name="first_name"]').val()) +
				'&Last_Name=' +
				encodeURIComponent(form.find('[name="last_name"]').val()) +
				'&Email=' +
				encodeURIComponent(form.find('[name="email"]').val()) +
				'&Phone=' +
				encodeURIComponent(form.find('[name="phone"]').val()) +
				'&Key=' +
				encodeURIComponent(bundleKey);

			$.ajax({
				url: url,
				type: 'GET',
				global: false,
				contentType: false,
				processData: false,
				success: function (response) {
					if (response) {
						var requests = [];
						var glasses = Cart.Items.prescription();
						for (var index in glasses) {
							var glass = glasses[index];
							glass.data.properties['Prescription Type'] = 'Send Later';

							requests.push(glass.change());
						}

						var defer = $.when.apply($, requests);
						defer.done(function () {
							/* Any implementation after changing
                                       cart line item. */
						});

						input.val(null);

						buttons.send.button('reset');
						buttons.call.add(buttons.send).prop('disabled', false);

						template
							.find('.active-line-item #prescription-send')
							.append('<p class="status bold"><span class="checkmark">&check;</span>&nbsp;Uploaded</p>');

						$('#send-later').modal('hide');

						//                             template.find('#prescription-option').fadeOut('fast', function() {
						//                                 template.find('[data-toggle="checkout"]').fadeIn('fast');
						//                             });
					}
				},
			});
		});

		template.on('click', 'button#prescription-send1', function () {
			var buttons = {
				upload: template.find('#prescription-upload'),
				call: template.find('#prescription-call'),
				send: $(this),
			};

			buttons.upload.add(buttons.call).prop('disabled', true);

			var requests = [];
			var glasses = Cart.Items.prescription();

			for (var index in glasses) {
				var glass = glasses[index];

				glass.data.properties['Prescription Type'] = 'Send Later';

				requests.push(glass.change());
			}

			var defer = $.when.apply($, requests);
			defer.done(function () {
				buttons.upload.add(buttons.call).prop('disabled', false);
				buttons.send.button('reset');

				template.find('#prescription-option').fadeOut('fast', function () {
					template.find('[data-toggle="checkout"]').fadeIn('fast');
				});
			});
		});

		cartQuantityButton.minus.on('click', function (e) {
			e.preventDefault();
		});

		cartQuantityButton.plus.on('click', function (e) {
			e.preventDefault();
		});
		cartQuantityButton.plus.on('click', function (e) {
			e.preventDefault();
		});
		template.on('click', '.trigger-reveal', function (e) {
			e.preventDefault();
			var description = $(this).siblings('.reveal');
			if (description.is(':visible')) {
				description.slideUp('slow');
			} else {
				description.slideDown('slow');
			}
		});
		minicartIsSetup = true;
	};

	function changeCartByLineProperty(data) {
		$.ajax({
			url: '/cart/change.js',
			type: 'post',
			dataType: 'json',
			async: false,
			data: {
				line: data.line,
				quantity: data.qty,
			},
		});
	}

	populateProductQty();

	$('form.cart .item-quantity .btn-link').on('click', function (e) {
		e.preventDefault();

		var qty = $('input#item_quantity-' + $(this).attr('data-id')).val(),
			line = $(this).attr('data-line');

		var data = {
			line: line,
			qty: qty,
		};

		changeCartByLineProperty(data);

		location.reload();
	});

	cartTemplateSetup();

	/**
	 * CAROUSELS
	 */
	const $global__announcementBar = $('#announcementSlider');
	if ($global__announcementBar.length) {
		$global__announcementBar.slick({
			autoplay: true,
			autoplaySpeed: 8000,
			speed: 1200,
			infinite: true,
			slidesToShow: 1,
		});
	}

	/**
	 * MISC
	 */
	$('a[data-scroll-to]')
		// Remove links that don't actually link to anything
		.not('[href="#"]')
		.not('[href="#0"]')
		.on('click', function (event) {
			// On-page links
			if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
				// Figure out element to scroll to
				var target = $(this.hash);

				target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
				// Does a scroll target exist?
				if (target.length) {
					// Only prevent default if animation is actually gonna happen
					event.preventDefault();

					$('html, body').animate(
						{
							scrollTop: target.offset().top,
						},
						1000,
						function () {
							// Callback after animation
							// Must change focus!
							var $target = $(target);
							$target.focus();
							if ($target.is(':focus')) {
								// Checking if the target was focused
								return false;
							} else {
								$target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
								$target.focus(); // Set focus again
							}
						}
					);
				}
			}
		});
};

initPairTheme(jQuery);
